import { SVGProps, Ref, forwardRef } from "react";

const SortLeftIcon = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 24 24"
    fill="currentColor"
    width="1em"
    height="1em"
    ref={ref}
    aria-label="Sort Left Icon"
    {...props}
  >
    <path d="m14 7-5 5 5 5V7Z" />
  </svg>
);

const ForwardRef = forwardRef(SortLeftIcon);
export default ForwardRef;
